import { Result } from '../components/kiosk/IndividualKioskResultsContent'

export default function isOnCourse(result: Result): boolean {
  const mostRecentInterval = result.intervals?.find(x => x.mostRecentInterval) || result.intervals[0]

  return mostRecentInterval && !mostRecentInterval.intervalFull
}
